var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"variant":"tmfooter"}},[_c('b-container',[_c('p',{staticClass:"text-muted"},[_vm._v(" Copyright © 2019 ZRY. All rights reserved. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }